import * as $ from "jquery";
import * as apiUser from "@startapp/loc-user-api";

const style = require("./style/index.scss");

const getUrlParameter = function getUrlParameter(sParam: string) {
    const sPageURL = decodeURIComponent(window.location.search.substring(1));
    const sURLVariables = sPageURL.split("&");

    for (let i = 0; i < sURLVariables.length; i++) {
        const sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

$(() => {
    $(".main_form").submit(ev => {
        ev.preventDefault();
        ev.stopPropagation();

        const pass1 = $("#pass1").val() as string;
        const pass2 = $("#pass2").val();

        if (pass1 !== pass2) {
            $(".repeated").addClass("invalid");
        } else {
            $(".flash").addClass("hidden");
            $(".repeated").removeClass("invalid");

            switch (getUrlParameter("type")) {
                case "user":
                default: {
                    if (!getUrlParameter("isStaging")) {
                        apiUser.setUrl("https://api.meuloc.com/user");
                    } else {
                        apiUser.setUrl("https://api.meuloc.com/user-staging");
                    }

                    apiUser.resetPassword(getUrlParameter("token") as string, pass1)
                        .then(() => {
                            $(".main_form").addClass("hidden");
                            $(".success_form").removeClass("hidden");
                            window.location.replace("https://meuloc.com");
                        })
                        .catch(err => {
                            console.error(err);
                            $(".flash").removeClass("hidden");
                            $(".main_form").addClass("shakeAnimation");

                            setTimeout(() => $(".main_form").addClass("shakeAnimation"), 820);
                        });
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/index.ts